import { render, staticRenderFns } from "./LocationsListView.vue?vue&type=template&id=8451b1b4&scoped=true&"
import script from "./LocationsListView.vue?vue&type=script&lang=js&"
export * from "./LocationsListView.vue?vue&type=script&lang=js&"
import style0 from "./LocationsListView.vue?vue&type=style&index=0&id=8451b1b4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8451b1b4",
  null
  
)

export default component.exports